class RegexPatterns {
  static EMAIL = /^[A-Za-z0-9.]+@[A-Za-z0-9-]+\.[a-zA-Z]{2,3}$/;
  static MOBILE = /^[0-9]{10,16}$/;
  static PASSWORD =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,20}$/;
  static USERNAME =
    /^(?=.{8,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/;
  static NAME_REGEXP = /^[a-zA-Z0-9\s_\-]{1,100}$/;
  static GENDER_REGEXP = /^(MALE|FEMALE|TRANSGENDER)$/;
  static SERVICE_NAME_REGEXP = /^[a-zA-Z0-9\s_\-]{2,50}$/;
  static SEARCH_NAME_REGEXP = /^[a-zA-Z0-9\s]{1,50}$/;
  static CODE_REGEXP = /^[A-Z0-9_\-]{2,50}$/;
  static NUMERIC_REGEXP = /^[0-9]{1,50}$/;
  static YES_NO_REGEXP = /^[YN]{1}$/;
  static DESCRIPTION_REGEXP = /^[a-zA-Z0-9\s.,\-()\[\]/;]{1,500}$/;
  static ADDRESS_LINE = /^[a-zA-Z0-9.\-\s,]{2,100}$/;
  static REFRESH_TOKEN = /^[a-zA-Z0-9\-]{20,50}$/;
  static VALID_URL =
    /^(https?:\/\/)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
  static TEMP_TYPE = /^(EMAIL|MOBILE|WHATSAPP|ALERT)$/;
  static FREQUENCY_TYPE = /^(ME|DY|HR|MH|WK)$/;
  static TIME_FORMAT_AM_PM = "hh:mm a";
  static DATE_FORMAT_DD_MM_YYYY = "dd/MM/yyyy";
  static DATETIME_FORMAT_AM_PM = "dd/MM/yyyy hh:mm a";
  static WEEK_DAYS = /^(SUN|MON|TUE|WED|THU|FRI|SAT|,)$/;
  static VALID_MAIL_SECURITY_TYPE = /^(SSL|TLS)$/;
  static VALID_MAIL_AUTH_TYPE = /^(OAUTH2|BASIC|UNSECURED)$/;
  static VALID_PROVIDER_TYPE =
    /^(TWILIO|MESSAGE_BIRD|PLIVO|SINCH|VONAGE|META|GOOGLE)$/;
  static VALID_OAUTH_PROVIDER = /^(GOOGLE|MICROSOFT|META)$/;
  static BOOK_PENALTY_TYPE = /^(LOST_ITEM|DAMAGED_ITEM|UNPAID_FINE)$/;
  static ADDRESS_ENTITY = /^(SITE|USER)$/;
  static ORGANIZATION_LEVEL = /^(USER|DEPARTMENT|GROUP|REGION|SITE)$/;
  static ACADEMIC_SESSION = /^\d{4}-\d{4}$/;
}

export default RegexPatterns;
